import script from "./system-parameter.vue?vue&type=script&setup=true&lang=js"
export * from "./system-parameter.vue?vue&type=script&setup=true&lang=js"

import "./system-parameter.vue?vue&type=style&index=0&id=a01ba000&lang=scss&scoped=true"
import "./system-parameter.vue?vue&type=style&index=1&id=a01ba000&lang=css"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a01ba000"]])

export default __exports__